require("ci5/smart_form");
require("ci5/modules/progressbar");
require("ci5/modules/comparison");
require("ci5/modules/interstitial");
require("ci5/modules/quote_comparison/comparison");
require("ci5/modules/quote_comparison/accordion");
require("ci5/modules/upsell/upsell");
require("ci5/modules/pop");
require("bijou/modules/grid");
require("bijou/modules/masthead");
require("ci5/modules/mailcheck");
require("direct_debit_form");
require("ci5/main");
require("ci5/carousel_v2");
require("ci5/handle_waiting_for_quotes_page");
require("ci5/modules/stripe_payment");
require("ci5/shopping-basket-header-side");
require("ci5/opening_hours_toggle");
require("ci5/disable_scroll_handler");
require("ci5/redirect-to-path");
require("ci5/handle_product_info");
require("ci5/modules/date_buttons");
require("ci5/modules/hidden_date_input");
require("ci5/us_state_select");
require("ci5/general-contractor-modal");
require("ci5/checkbox_focus");
require("ci5/consolidated-questions.js");
require("ci5/start_help_chat");
require("ci5/ai_trade_selector");
require("ci5/new_quote_details");
require("ci5/copy_link_to_clipboard.js");
